import PropTypes from 'prop-types';
import React from 'react';
import BaseBadge from '../BaseBadge';
import styles from './styles.scss';

const TransferBadge = ({ transfer, className, ...rest }) => {
  const styleKey = transfer.type;
  const mergedClassName = `${styles[styleKey]} ${className}`;
  const badgeLabel = () => {
    switch (transfer.type) {
      case 'topup':
        return 'チャージ';
      case 'payment':
        return '支払い';
      case 'campaign-topup':
        return 'キャンペーン特典';
      case 'use-coupon':
        return 'クーポン適用';
      case 'refund-topup':
        return 'キャンセル(チャージ)';
      case 'refund-payment':
        return 'キャンセル(支払い)';
      case 'refund-campaign':
        return 'キャンセル(キャンペーン特典)';
      case 'refund-coupon':
        return 'キャンセル(クーポン適用)';
      case 'exchange-inflow':
        return '交換(流入)';
      case 'exchange-outflow':
        return '交換(流出)';
      case 'transfer':
        return 'マネー譲渡';
      case 'expire':
        return '失効';
      case 'cashback':
        return '返金';
      default:
        return '不明';
    }
  };
  return (
    <BaseBadge className={mergedClassName} {...rest}>
      {badgeLabel()}
    </BaseBadge>
  );
};

TransferBadge.propTypes = {
  transfer: PropTypes.shape({ type: PropTypes.string }).isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
};

TransferBadge.defaultProps = {
  type: '',
  className: '',
};

export default TransferBadge;
